
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"24","height":"24"}}),_c('path',{attrs:{"d":"M13.2615 22.0055H10.6383M14.1358 20.2568H9.76393M11.9499 1.89474V4.51789M4.53001 4.96821L6.38545 6.82277M19.3692 4.96821L17.5146 6.82277M1.89453 12.3873H4.51768M22.0053 12.3873H19.3821M17.1963 12.3874C17.1973 11.4851 16.9656 10.5977 16.5235 9.81112C16.0814 9.02453 15.4439 8.36525 14.6725 7.897C13.9012 7.42875 13.0222 7.16735 12.1203 7.13806C11.2185 7.10878 10.3243 7.31259 9.52424 7.72981C8.72417 8.14703 8.04523 8.76355 7.55302 9.51981C7.06081 10.2761 6.77198 11.1465 6.71443 12.047C6.65687 12.9475 6.83255 13.8476 7.22447 14.6603C7.6164 15.4731 8.21133 16.171 8.95178 16.6867C9.06756 16.7672 9.16215 16.8746 9.22747 16.9996C9.29279 17.1246 9.3269 17.2635 9.32689 17.4046V18.0709C9.32689 18.1868 9.37295 18.298 9.45494 18.38C9.53693 18.462 9.64813 18.5081 9.76408 18.5081H14.136C14.2519 18.5081 14.3631 18.462 14.4451 18.38C14.5271 18.298 14.5732 18.1868 14.5732 18.0709V17.4037C14.5732 17.2627 14.6073 17.1237 14.6726 16.9987C14.7379 16.8737 14.8325 16.7664 14.9483 16.6858C15.6424 16.2043 16.2094 15.5617 16.6009 14.8131C16.9924 14.0645 17.1967 13.2322 17.1963 12.3874Z","stroke":"url(#paint0_linear_72_3287)","stroke-width":"1.37119","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_72_3287","x1":"0.563673","y1":"3.12278","x2":"12.2353","y2":"28.8309","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0.146058","stop-color":"#0FB1AF"}}),_c('stop',{attrs:{"offset":"0.901042","stop-color":"#91469D"}})])])])
          )
        }
      }
    